import { Button, Card } from 'antd';
import React, { useState } from 'react';
import Chart from "react-google-charts";
import { mapData } from './DistrictsList';


const DistrictMap = () => {

    const [data, setData] = useState([["Lat", "Lon"]]);

    var options = {
        region: 'IN',
        domain: 'IN',
        displayMode: 'markers',
        resolution: 'provinces',
        sizeAxis: { minValue: 2 },
        // colorAxis: {colors: ['#00853f', 'black', '#e31b23']},
        backgroundColor: '#81d4fa',
        // datalessRegionColor: 'Grey',
        // defaultColor: '#f5f5f5',
        colorAxis: { colors: ['blue', 'red', '#956ee7', '#956ee7'] }
    };

    const loadDistricts = () => {
        setData(mapData)
    }



    return (
        <>
            <Card title=" Districts Map" className='gx-card' style={{ height: "100%" }} >
                <Button type='primary' onClick={loadDistricts}>Load  Districts </Button>
                <Chart
                    chartType="GeoChart"
                    width="100%"
                    height="80vh"
                    //  keepAspectRatio={true}
                    data={data}
                    options={options}
                />
            </Card>
        </>
    )
}


export default DistrictMap;